import React, { useEffect, useState } from 'react';
import {
  Grid,
  makeStyles,
  FormControl,
  Typography,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ApplicationState } from 'store';
import 'translations/translations';
import { organizationActions } from 'actions/organizationActions';
import {
  ExportFormatEnumDto,
  MeasurementCardDetails,
  StackNumberingEnumDto,
} from '.generated/api';
import { ApiService } from 'services/apiService';

type StepProps = {
  stepTitleString: string;
  buttonText: string;
};

const useStyles = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
    textAlign: 'right',
    fontSize: '0.8rem',
  },
}));

const AddMeasurementCardStep: React.FC<StepProps> = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['translations']);
  const classes = useStyles();
  const [measurementCards, setMeasurementCards] = useState<
    MeasurementCardDetails[]
  >([]);
  const [inputs, setInputs] = useState({
    stackNumbering: StackNumberingEnumDto.AUTO_GENERATED,
    measurementCard: '',
    exportFormat: ExportFormatEnumDto.CSV,
  });
  const [measurementCardsError, setMeasurementCardsError] =
    useState<string>('');

  const organizationError = useSelector(
    (state: ApplicationState) => state.organization?.error,
  );

  const organizationId = useSelector(
    (state: ApplicationState) => state.organization?.id,
  );

  const handleSelect = (
    inputName: string,
    e: React.ChangeEvent<{ name?: string | undefined; value: unknown }>,
  ) => {
    const { value } = e.target;
    setInputs((inputs) => ({ ...inputs, [inputName]: value }));
  };

  const callbackFn = () => {
    dispatch(
      organizationActions.assignMeasurementCardToOrg(
        organizationId,
        inputs.measurementCard,
        inputs.stackNumbering,
        inputs.exportFormat,
      ),
    );
  };

  useEffect(() => {
    dispatch({ type: 'SET_CALLBACK', callbackFn });
  });

  useEffect(() => {
    ApiService.getMeasurementCardList()
      .then((response) => {
        const details = response?.data?.details;
        if (details && details.length > 0) {
          setMeasurementCards(details);
          setInputs((inputs) => ({
            ...inputs,
            measurementCard: details[0].measurementCardId || '',
          }));
        }
      })
      .catch((error) => {
        setMeasurementCardsError(error?.response?.data?.errorMessage);
      });
  }, []);

  return (
    <>
      <Grid item xs={6}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel>
            {t(
              'organizations_page.create_org.add_measurement_card_step.stack_numbering',
            )}
          </InputLabel>
          <Select
            value={inputs.stackNumbering}
            onChange={(e) => handleSelect('stackNumbering', e)}
            label={t(
              'organizations_page.create_org.add_measurement_card_step.stack_numbering',
            )}
            id="stackDD"
          >
            <MenuItem value={StackNumberingEnumDto.AUTO_GENERATED}>
              {t(
                'organizations_page.create_org.add_measurement_card_step.autogenerated',
              )}
            </MenuItem>
            <MenuItem value={StackNumberingEnumDto.MANUEL}>
              {t(
                'organizations_page.create_org.add_measurement_card_step.manuel',
              )}
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel>
            {t(
              'organizations_page.create_org.add_measurement_card_step.measurement_card',
            )}
          </InputLabel>
          <Select
            value={inputs.measurementCard}
            onChange={(e) => handleSelect('measurementCard', e)}
            label={t(
              'organizations_page.create_org.add_measurement_card_step.measurement_card',
            )}
            id="cardDD"
          >
            {measurementCards?.map((card, index) => {
              return (
                <MenuItem key={index} value={card.measurementCardId || ''}>
                  {card.measurementCardName}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
      {/*
      <Grid item xs={6}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel>
            {t('organization_page.measurement_card.labels.export_format')}
          </InputLabel>
          <Select
            value={inputs.exportFormat}
            onChange={(e) => handleSelect('exportFormat', e)}
            label={t('organization_page.measurement_card.labels.export_format')}
            id="stackDD"
          >
            <MenuItem value={ExportFormatEnumDto.CSV}>
              {t('organization_page.measurement_card.export_formats.csv')}
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>
      */}
      <Typography className={classes.error}>
        {!!organizationError && organizationError}
        {!!measurementCardsError && measurementCardsError}
      </Typography>
    </>
  );
};

export { AddMeasurementCardStep };
